import { FormInstance, message, Modal, notification } from "antd"

export const displayLanguageByKey = (key: string) => {
  switch (key) {
    case "ru":
      return "Русский"

    default:
      return "-"
  }
}

export const showErrorMessage = (text: string) => {
  message.open({
    content: text,
    type: "error",
    style: { marginTop: 40 }
  })
}

export const showSuccessMessage = (text: string) => {
  message.open({
    content: text,
    type: "success",
    style: { marginTop: 40 }
  })
}

export const showErrorNotification = (text: string, duration = 5) => {
  notification.open({
    type: "error",
    message: "Ошибка!",
    description: text,
    duration: duration
  })
}

/** Длина, после которой текст уже не помещается в уведомление */
const LONG_MESSAGE_TEXT_LENGTH = 200

/** Прокручиваемый блок для длинного текста в модалке */
const renderLongText = (text: string) => (
  <div style={{ maxHeight: "60vh", overflowY: "auto", whiteSpace: "pre-wrap" }}>
    {text}
  </div>
)

/**
 * Показывает ошибку целиком: короткую — уведомлением, длинную — в модалке
 * с прокруткой. Бэк при частичном успехе массовых действий OZON перечисляет
 * в ответе все непрошедшие заказы с причинами, такой текст обрезать нельзя.
 */
export const showErrorByLength = (text: string) => {
  if (text.length > LONG_MESSAGE_TEXT_LENGTH) {
    Modal.error({
      title: "Ошибка!",
      width: 600,
      content: renderLongText(text)
    })
    return
  }

  showErrorNotification(text)
}

/**
 * Показывает отчёт об успехе целиком: короткий — всплывающим сообщением,
 * длинный — в модалке с прокруткой (например, отчёт OZON после
 * «Обновить статусы и стикеры»).
 */
export const showSuccessByLength = (text: string) => {
  if (text.length > LONG_MESSAGE_TEXT_LENGTH) {
    Modal.success({
      title: "Готово",
      width: 600,
      content: renderLongText(text)
    })
    return
  }

  showSuccessMessage(text)
}

export const showSuccessNotification = (text: string, duration = 5) => {
  notification.open({
    type: "success",
    message: "Успех!",
    description: text,
    duration: duration
  })
}

export const showInfoNotification = (text: string, duration = 5) => {
  notification.open({
    type: "info",
    message: "Внимание!",
    description: text,
    duration: duration
  })
}

export const showFormErrors = (
  form: FormInstance,
  errors: {[key: string]: string}
) => {
  Object.entries(errors).forEach(([ key, val ]) => {
    form.setFields([
      {
        name: key,
        errors: [ val ]
      }
    ])
  })
}

export const openLink = (link: string, newWindow = false) => {
  if (newWindow) {
    window.open(link)
  } else {
    window.location.href = link
  }
}
